<svg class="nub" viewBox="-9879.557 4427.44 140.557 162.299">
  <g class="nub-group" transform="translate(-9879.557 4427.44)">
    <path class="nub-path" d="M0,45.69l140.556,81.148v-162.3Z" transform="translate(0 35.461)"/>
  </g>
</svg>
